export default __webpack_public_path__ + "static/media/support_qrcode.7cd8dbb3.jpg";